module.exports = __webpack_public_path__ + "static/media/The Racer - Piano Version.fe9b5cc8.jpg";